import React from "react";
import { Instagram, Youtube, Twitter, Facebook, Send } from "lucide-react";
import { useSettings } from "../lib/useSettings";

const ICONS = {
  instagram: Instagram,
  youtube: Youtube,
  twitter: Twitter,
  facebook: Facebook,
  telegram: Send,
};

export default function SocialLinks({ variant = "dark", size = "md", showLabels = false }) {
  const { settings } = useSettings();
  const social = settings.social || {};
  const items = [
    { key: "instagram", url: social.instagram, label: social.instagram_handle || "@bodhnetworks" },
    { key: "youtube", url: social.youtube, label: social.youtube_handle || "@bodhnetworks" },
    { key: "twitter", url: social.twitter, label: "Twitter" },
    { key: "facebook", url: social.facebook, label: "Facebook" },
    { key: "telegram", url: social.telegram, label: "Telegram" },
  ].filter((x) => x.url);

  const isLight = variant === "light";
  const dim = size === "sm" ? "h-8 w-8" : "h-9 w-9";

  return (
    <div className={`flex items-center ${showLabels ? "gap-2 flex-wrap" : "gap-1.5"}`} data-testid="social-links">
      {items.map((it) => {
        const Icon = ICONS[it.key];
        return (
          <a
            key={it.key}
            href={it.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`social-${it.key}`}
            aria-label={it.key}
            className={`${dim} inline-flex items-center justify-center rounded-full transition border ${
              isLight
                ? "bg-white/5 hover:bg-white/15 text-white border-white/10"
                : "bg-zinc-100 hover:bodh-gradient hover:text-white text-zinc-700 border-zinc-200"
            }`}
          >
            <Icon className="h-4 w-4" />
          </a>
        );
      })}
    </div>
  );
}

export function FollowButton({ network = "instagram" }) {
  const { settings } = useSettings();
  const social = settings.social || {};
  const url = social[network];
  const Icon = ICONS[network] || Instagram;
  const handle = social[`${network}_handle`] || "@bodhnetworks";
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`follow-${network}`}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bodh-gradient text-white text-xs font-outfit font-bold hover:opacity-95 transition"
    >
      <Icon className="h-3.5 w-3.5" /> Follow {handle}
    </a>
  );
}
